import { SuiteManifest } from '../manifest';
import { salesRoutes } from './routes';
import { salesNavItems } from './nav';

export const salesManifest: SuiteManifest = {
  id: 'sales',
  name: 'Sales',
  basePath: '/sales',
  icon: 'briefcase',
  description: 'Sales suite modules and operations.',
  nav: salesNavItems,
  routes: salesRoutes,
};

export default salesManifest;
